import { render, staticRenderFns } from "./riskOverviewComponent.vue?vue&type=template&id=44313698"
import script from "./riskOverviewComponent.vue?vue&type=script&lang=js"
export * from "./riskOverviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports